<template>
  <Catalog
    title="Статус объекта"
    name-label="Название статуса"
    submit-error="Укажите название статуса объекта."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :exact-id="createId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "LocationStatus",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    createId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getLocationStatusById(id);
    },
    async putData(data) {
      return await this.putLocationStatus(data)
    },
    async postData(data) {
      return await this.postLocationStatus(data)
    },
  }
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/Catalogs/LocationStatuses/LocationStatus.vue